import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dragdroptable',
  templateUrl: './dragdroptable.component.html',
  styleUrls: ['./dragdroptable.component.scss']
})
export class DragdroptableComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
